import { useState } from 'react';
import { Link, Stack, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { plural } from '../../shared/plural';

/** Ile uwag widać od razu; resztę rozwija „+N uwag". */
export const WARNINGS_SHOWN = 2;

const moreLabel = (n: number) => `+${plural(n, 'uwaga', 'uwagi', 'uwag')}`;

/**
 * Uwagi przy podpowiedzi (pojazd → zlecenie i zlecenie → pojazd).
 *
 * Kandydat potrafi mieć cztery zdania ostrzeżeń, a kolumna „Uwagi" rosła
 * wtedy wzwyż i wszerz, spychając liczby w łamanie. Pokazujemy dwie pierwsze
 * w kolejności z API, resztę za „+N uwag" — nic nie
 * znika, jest o jedno kliknięcie dalej. Pusta lista to „—", nie pusta
 * komórka, bo pusta wygląda jak niedoczytane dane.
 */
export function WarningsList({ warnings }: { warnings: string[] }) {
  const [expanded, setExpanded] = useState(false);
  if (warnings.length === 0) return <>—</>;
  const hidden = warnings.length - WARNINGS_SHOWN;
  const shown = expanded || hidden <= 0 ? warnings : warnings.slice(0, WARNINGS_SHOWN);
  return (
    <Stack spacing={0.25}>
      {shown.map((w) => (
        <Stack key={w} direction="row" spacing={0.5} sx={{ alignItems: 'flex-start' }}>
          <WarningAmberIcon fontSize="inherit" color="warning" sx={{ mt: '2px', flexShrink: 0 }} />
          <Typography variant="caption">{w}</Typography>
        </Stack>
      ))}
      {hidden > 0 && (
        <Link
          component="button"
          type="button"
          variant="caption"
          underline="hover"
          onClick={() => setExpanded((e) => !e)}
          sx={{ alignSelf: 'flex-start', whiteSpace: 'nowrap' }}
        >
          {expanded ? 'zwiń uwagi' : moreLabel(hidden)}
        </Link>
      )}
    </Stack>
  );
}
